import { memo } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';

import { TranslationItem, TranslationKey, TranslationValue } from './styled';
import type { TrackedTranslation } from './types';

type Props = {
  translation: TrackedTranslation;
  onClick: (translation: TrackedTranslation) => void;
};

export const TranslationListItem = memo(function TranslationListItem({ translation, onClick }: Props) {
  const handleClick = useCallbackRef(() => onClick(translation));

  return (
    <TranslationItem onClick={handleClick} data-testid={`translation-item-${translation.fullKey}`}>
      <TranslationKey>{translation.fullKey}</TranslationKey>
      <TranslationValue>{translation.value}</TranslationValue>
    </TranslationItem>
  );
});
